export default __webpack_public_path__ + "static/media/background.2f10f96c.png";